/**
 * Authoritative persisted/display Total Depth.
 *
 * Run-sheet input/calculation formulas remain method-specific. This helper is
 * the single value consumers should use after those calculations have been
 * performed. It also repairs legacy split Conventional Core records that
 * stored only Rod 1's To Depth.
 */
export function getTotalDepth(run, holeType, rodLength = 6) {
  const rawTo = Number(run?.to_depth);
  if (!Number.isFinite(rawTo)) return null;

  const from = Number(run?.from_depth);
  if (holeType !== "Conventional" || !Number.isFinite(from)) return rawTo;

  const hasRod2 =
    run?.rod2_number != null ||
    run?.rod2_end_stick_up != null ||
    run?.rod2_drilled != null;
  if (!hasRod2) return rawTo;

  // Current saves persist the combined To Depth. Legacy split records stored
  // only Rod 1's depth, so reconstruct those records once at read time.
  const storedDrilled = rawTo - from;
  if (!Number.isFinite(storedDrilled) || storedDrilled >= 4.5 - 0.001) return rawTo;

  const rod2EndStickUp = Number(run?.rod2_end_stick_up);
  const rod2Drilled = Number.isFinite(rod2EndStickUp)
    ? Math.max(0, Number(rodLength || 6) - rod2EndStickUp)
    : Number(run?.rod2_drilled);

  if (!Number.isFinite(rod2Drilled)) return rawTo;
  return +(rawTo + rod2Drilled).toFixed(2);
}

export function getDrilledDepth(run, holeType, rodLength = 6) {
  const total = getTotalDepth(run, holeType, rodLength);
  const from = Number(run?.from_depth);
  if (!Number.isFinite(total) || !Number.isFinite(from)) return null;
  return +(total - from).toFixed(2);
}
